var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1552_6828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H22.6966V22.6689H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1552_6828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64251 3.5C4.73851 3.5 3.49951 4.976 3.49951 8.433V16.232C3.49951 19.416 5.25751 21.169 8.44951 21.169H16.2315C19.4155 21.169 21.1685 19.416 21.1685 16.232V16.229L21.1965 11.264C21.1965 7.865 20.0305 6.54 17.0355 6.54H14.2055C13.2565 6.539 12.3505 6.086 11.7805 5.328L10.8675 4.114C10.5805 3.729 10.1215 3.501 9.64151 3.5H7.64251ZM16.2315 22.669H8.44951C4.47151 22.669 1.99951 20.202 1.99951 16.232V8.433C1.99951 4.164 3.89851 2 7.64251 2H9.64251C10.5935 2.001 11.4995 2.455 12.0675 3.214L12.9785 4.426C13.2675 4.81 13.7265 5.039 14.2065 5.04H17.0355C20.8975 5.04 22.6965 7.019 22.6965 11.268L22.6685 16.235C22.6675 20.203 20.2015 22.669 16.2315 22.669Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.716 15.7128H7.98096C7.56696 15.7128 7.23096 15.3768 7.23096 14.9628C7.23096 14.5488 7.56696 14.2128 7.98096 14.2128H16.716C17.13 14.2128 17.466 14.5488 17.466 14.9628C17.466 15.3768 17.13 15.7128 16.716 15.7128Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEvent);
export default __webpack_public_path__ + "static/media/menu_event.be418a5f66382fdcdff3bc3331c35d0a.svg";
export { ForwardRef as ReactComponent };